// import React, { useState } from "react";
// // import "./App.css";

// import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

// import ScrollToTop from "./components/common/ScrollToTop";
// import Tophead from "./components/common/Tophead";
// import Header from "./components/common/Header";
// import Banner from "./components/common/Banner";
// import Footer from "./components/common/Footer";
// import Loader from "./components/common/Loader";

// import Home from "./components/pages/home/Home";
// import About from "./components/pages/about/About";
// import Teacher from "./components/pages/teacher/Teacher";
// import Teacherlist from "./components/pages/teacher/Teacherlist";
// import VideoView from "./components/pages/teacher/VideoView";
// import TeacherRegistration from "./components/pages/teacher/TeacherRegistration";
// import Plans from "./components/pages/batch/Plans";
// import StudentLogin from "./components/pages/student/StudentLogin";
// import StudentRegistration from "./components/pages/student/StudentRegistration";
// import Contact from "./components/common/Contact";
// import CourseBatch from "./components/pages/batch/Batches";
// import ParchaseBatch from "./components/pages/batch/ParchaseBatch";
// import AllVideo from "./components/pages/teacher/AllVideo";
// import NotesBook from "./components/pages/teacher/NotesBook";
//  import Paynow from "./components/pages/payment/Paynow";
// import OffcanvasForm from "./components/common/OffcanvasForm";
// import "./components/common/OffcanvasForm.css";
// import { MessageCircle } from "lucide-react";

// function App() {
//   const [isOpen, setIsOpen] = useState(false);

//   return (
//     <Router>
//       <ScrollToTop /> {/* This scrolls to top on every route change */}
//       <div className="full-width-header">
//         <Tophead />
//         <Header />
//       </div>
//       <Banner />
//       <div
//         className="fixed-icon"
//         onClick={() => setIsOpen(true)}
//         title="Contact us"
//       >
//         {/* Optional icon or just emoji/text */}
//         <MessageCircle size={24} />
//       </div>
//       <OffcanvasForm isOpen={isOpen} onClose={() => setIsOpen(false)} />
//       <Routes>
//         {/* ROUTES */}
//         <Route path="/" element={<Home />} />
//         <Route path="/topfaculty-about-us" element={<About />} />

//         {/* TEACHER ROUTES */}
//         <Route path="/facultyregister" element={<TeacherRegistration />} />
//         <Route path="/teacher/:id/:name" element={<Teacher />} />
//         <Route path="/myteacherlist" element={<Teacherlist />} />
//         <Route path="/myteacherlist/:examId" element={<Teacherlist />} />
//         <Route path="/runningvideo/:link/:topic" element={<VideoView />} />

//         {/* STUDENT ROUTES */}
//         <Route path="/studentlogin" element={<StudentLogin />} />
//         <Route path="/studentregister" element={<StudentRegistration />} />
//         <Route path="/contact-us" element={<Contact />} />

//         {/* BATCHES AND RESOURCES */}
//         <Route path="/course-batch" element={<CourseBatch />} />
//         <Route path="/all-Videos" element={<AllVideo />} />
//         <Route path="/all-notes" element={<NotesBook />} />

//         {/* PAYMENT */}
//         <Route path="/paynowicici" element={<Paynow />} />
//       </Routes>
//       <Footer />
//     </Router>
//   );
// }

// export default App;

import React, { useState, useEffect } from "react";
import {
   HashRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import ScrollToTop from "./components/common/ScrollToTop";
import Tophead from "./components/common/Tophead";
import Header from "./components/common/Header";
import Banner from "./components/common/Banner";
import Footer from "./components/common/Footer";
import Loader from "./components/common/Loader";
import Blogs from "./components/pages/blog/Blogs";
import BlogDetails from "./components/pages/blog/BlogDetails";
import Home from "./components/pages/home/Home";
import { Privacypolicy } from "./components/pages/home/Privacypolicy";
import { Refundpolicy } from "./components/pages/home/Refundpolicy";
import { Termsconditions } from "./components/pages/home/Termsconditions";
import About from "./components/pages/about/About";
import Teacher from "./components/pages/teacher/Teacher";
import Teacherlist from "./components/pages/teacher/Teacherlist";
import VideoView from "./components/pages/teacher/VideoView";
import TeacherRegistration from "./components/pages/teacher/TeacherRegistration";
import Plans from "./components/pages/batch/Plans";
import StudentLogin from "./components/pages/student/StudentLogin";
import StudentProfile from "./components/pages/student/StudentProfile";
import Stu_login from "./components/pages/student/Stu_login";
import Stu_verify from "./components/pages/student/Stu-verify";
import StudentRegistration from "./components/pages/student/StudentRegistration";
import StudentregReffer from "./components/pages/student/StudentregReffer";
import Contact from "./components/common/Contact";
import CourseBatch from "./components/pages/batch/Batches";
import Orders from "./components/pages/student/Orders";
import ParchaseBatch from "./components/pages/batch/ParchaseBatch";
import AllVideo from "./components/pages/teacher/AllVideo";
import NotesBook from "./components/pages/teacher/NotesBook";
import Paynow from "./components/pages/payment/Paynow";
import OffcanvasForm from "./components/common/OffcanvasForm";
import WhatsAppFloating from "./components/common/WhatsAppFloating";
import Calling from "./components/common/Calling";
import "./components/common/OffcanvasForm.css";
import ModalForm from "./components/common/ModalForm";
import { MessageCircle } from "lucide-react";

function AppContent() {
 const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  // Loader logic
  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 400);
    return () => clearTimeout(timer);
  }, [location]);

  // Modal logic (only on homepage "/")
  useEffect(() => {
    if (location.pathname === "/") {
      const timer = setTimeout(() => {
        setShowModal(true);
      }, 3000);
      return () => clearTimeout(timer);
    } else {
      setShowModal(false);
    }
  }, [location.pathname]);

  // ✅ Do this AFTER all hooks are declared
  if (loading) return <Loader />;

  return (
    <>


 {/* Modal Component */}
      <ModalForm show={showModal} onClose={() => setShowModal(false)} />
 
      <ScrollToTop />
      <div className="full-width-header">
        <Tophead />
        <Header />
      </div>

      {/* <Banner /> */}

      {/* Contact icon floating */}
      <div
        className="fixed-icon"
        onClick={() => setIsOpen(true)}
        title="Contact us"
      >
        <MessageCircle size={24} />
      </div>
      <OffcanvasForm isOpen={isOpen} onClose={() => setIsOpen(false)} />

      <WhatsAppFloating />
      <Calling />

      <Routes>
        {/* ROUTES */}
        <Route path="/" element={<Home />} />
        <Route path="/topfaculty-about-us" element={<About />} />
        <Route path="/privacy-policy" element={<Privacypolicy />} />
        <Route path="/refund-policy" element={<Refundpolicy />} />
        <Route path="/terms-conditions" element={<Termsconditions />} />
        {/* TEACHER ROUTES */}
        <Route path="/facultyregister" element={<TeacherRegistration />} />
        <Route path="/teacher/:id/:name" element={<Teacher />} />
        <Route path="/myteacherlist" element={<Teacherlist />} />
        <Route path="/myteacherlist/:examId" element={<Teacherlist />} />
        <Route path="/runningvideo/:link/:topic/:vid_id" element={<VideoView />} />
        {/* STUDENT ROUTES */}
        {/* <Route path="/studentlogin" element={<StudentLogin />} />   */}
        <Route path="/studentlogin" element={<Stu_login />} />
         <Route path="/verify-otp" element={<Stu_verify />} />
        <Route path="/studentregister" element={<StudentRegistration />} />
        <Route path="/StudentregReffer/:referral_code" element={<StudentregReffer />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/my-orders" element={<Orders />} />
        <Route path="/student-profile" element={<StudentProfile />} />
        {/* BATCHES AND RESOURCES */}
        {/* <Route path="/course-batch" element={<CourseBatch />} /> */}
        <Route path="/our-batches" element={<ParchaseBatch />} />
        <Route path="/all-Videos" element={<AllVideo />} />
        <Route path="/all-notes" element={<NotesBook />} />
        {/* PAYMENT */}
        <Route path="/paynowicici" element={<Paynow />} />
        <Route path="/our-package-plans" element={<Plans />} />
        {/* BLOGS */}
        <Route path="/daily-update" element={<Blogs />} />
         <Route path="/blogdetails/:blogId" element={<BlogDetails />} />
      </Routes>

      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
